// extracted by mini-css-extract-plugin
export var buttonContainer = "styles-module__buttonContainer___PnYAO";
export var chevronContainer = "styles-module__chevronContainer___o_B1u";
export var container = "styles-module__container___J0EEF";
export var descriptionContainer = "styles-module__descriptionContainer___uQPSO";
export var desktopLogo = "styles-module__desktopLogo___bxK8u";
export var image = "styles-module__image___EPguE";
export var imageContainer = "styles-module__imageContainer___zpGGP";
export var innerContainer = "styles-module__innerContainer___HXhO1";
export var mobileLogo = "styles-module__mobileLogo___sOdDz";